import client from 'client';

import { SERVER_URL } from 'constants/index';

const getUrl = () => {
    return `${SERVER_URL}/api/v1/transfers/paidfeatures/info`;
}

const getFeatures = async () => {
    const url = getUrl();

    return await client.get(url)
}

export default getFeatures;